import {
  Component,
  Inject,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Location, isPlatformBrowser } from '@angular/common';

import { LanguageToken } from '@app/core/env.tokens';
import { StorageService } from '@services/logic/storage.service';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { MatIconModule } from '@angular/material/icon';
import type { LanguageCode } from '@handyhand/i18n';

@Component({
  imports: [TranslatePipe, MatIconModule],
  selector: 'app-video-dialog',
  templateUrl: './videoDialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../dialogs.scss', './videoDialog.scss'],
})
export class VideoDialogComponent implements OnInit, OnDestroy {
  private readonly defaultLanguage = inject(LanguageToken);
  public language: LanguageCode = this.defaultLanguage;
  title!: string;
  vidChoice!: String;

  // Static property to track if any video dialog is open
  private static isAnyDialogOpen = false;

  constructor(
    private storage: StorageService,
    private location: Location,
    public dialogRef: MatDialogRef<VideoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    // Prevent multiple dialogs from being opened
    if (VideoDialogComponent.isAnyDialogOpen) {
      this.dialogRef.close();
      return;
    }

    VideoDialogComponent.isAnyDialogOpen = true;

    this.title = data.title;
    this.vidChoice = data.vidChoice;
    if (isPlatformBrowser(this.platformId)) {
      this.language = this.storage.languageCookie ?? this.defaultLanguage;
    }
  }

  ngOnInit(): void {
    // Only execute browser-specific code when running in the browser
    if (isPlatformBrowser(this.platformId)) {
      // Handle browser back button
      // Add a history entry to prevent immediate back navigation
      // this.location.go(this.location.path());
      // Listen for popstate events (back button)
      //window.addEventListener('popstate', this.popStateListener);
    }
  }

  ngOnDestroy(): void {
    // Only execute browser-specific code when running in the browser
    if (isPlatformBrowser(this.platformId)) {
      // Clean up event listener
    }

    // Reset the static flag when dialog is destroyed
    VideoDialogComponent.isAnyDialogOpen = false;
  }

  close(res: any = null): void {
    VideoDialogComponent.isAnyDialogOpen = false;
    this.dialogRef.close(res);
  }
}
